import React from 'react';
import styled from 'styled-components';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';

const DescargaExportButtons = ({
  onExportExcel,
  onExportPdf,
  loadingExport,
  disabled
}) => (
  <ActionsWrap>
    <ButtonWithLoading
      variant="success"
      size="sm"
      onClick={onExportExcel}
      loading={loadingExport === 'excel'}
      disabled={disabled}
    >
      <Icon name="file-excel" size={14} />
      <span>Exportar Excel</span>
    </ButtonWithLoading>
    <ButtonWithLoading
      variant="danger"
      size="sm"
      onClick={onExportPdf}
      loading={loadingExport === 'pdf'}
      disabled={disabled}
    >
      <Icon name="file-pdf" size={14} />
      <span>Exportar PDF</span>
    </ButtonWithLoading>
  </ActionsWrap>
);

export default DescargaExportButtons;

const ActionsWrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  button {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  @media (max-width: 480px) {
    width: 100%;

    button {
      flex: 1 1 auto;
      justify-content: center;
    }

    span {
      display: none;
    }
  }
`;
